// ============================================================================
// B TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'b-tree',
  name: 'B Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A self-balancing search tree that maintains sorted data and allows searches, insertions, and deletions in logarithmic time. Designed for disk storage with large nodes, minimizing disk I/O operations.'
};
